// extracted by mini-css-extract-plugin
export default {"container":"Phone2_container__75Eoc","input":"Phone2_input__CQAxw","button":"Phone2_button__BcwWN","dropdown":"Phone2_dropdown__hkFoB","search":"Phone2_search__MuPHz"};